import { COOKIE_CONSENT_KEY, IS_IRAN_KEY } from './constants'

export enum CookieConsentValues {
    Denied = 'DENIED',
    Granted = 'GRANTED',
}

export interface CookieConsentContextValueType {
    changeCookieConsentHander: (value: CookieConsentValues) => void
    addCallbackToQueue: (callback: () => void) => void
    fireAllCallbacks: () => void
    closeConsentModal: () => void
    isConsentModalOpen: boolean
}

export type CallbackType = () => void

export type ConsentCookieKeys = typeof COOKIE_CONSENT_KEY | typeof IS_IRAN_KEY
export interface ConsentCookieValues {
    [COOKIE_CONSENT_KEY]: CookieConsentValues | undefined
    [IS_IRAN_KEY]: boolean | undefined
}
